export const SET_SECTION_LIST = 'set-section-list';
export const SET_TABLE_ORDER_DETAILS = 'set_table_order_details';
export const SET_ACTIVE_TABLE_ID = 'set_active_table_id';
